import cartItemShipDatePrompt from "emun.cart/cart-item-ship-date";
import labels from "emun.order/_labels";
import orderConfig from "emun.order/order.config";
import modals from "webmodals/modals";
import partsEntryGridTemplate from "emun.order/parts/parts-entry-grid.htm";
import Product from "emun.shopping/product.model";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";

export default class OrderMultiAddController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.partsEntryGridTemplate = partsEntryGridTemplate;
    //console.debug("OrderMultiAddController", $ctrl);
    $ctrl.title = $ctrl.updateItems ? "Update Products..." : "Add Products...";
    if ($ctrl.updateItems) {
      $ctrl.subTitle =
        "You have to click Update Products when you are done with your changes!";
    }
    $ctrl.labels = labels;
    $ctrl.orderConfig = orderConfig;
    var url = "QueryProducts.json?src=OrderMultiAddController";
    if ($ctrl.criteria.idIn) url = url + "&idIn=" + $ctrl.criteria.idIn;
    $ctrl.query = new AutoQuery({
      url: "QueryProducts.json?src=OrderMultiAddController",
      autoLoad: true,
      httpMethod: $ctrl.httpMethod,
      criteria: {
        op: "OrderMultiAddController",
        ...$ctrl.criteria,
        MaxNumLines: 0
      },
      pageSize: $ctrl.orderConfig.multiAddPageSize || 250, // safety precaution
      beforeLoading({ request }) {
        request.cartId = $ctrl.$cart.cartId;
      },
      onLoaded(args) {
        args.results.forEach(function (obj) {
          obj.priceOverride = obj.price;
          //console.info("obj1", obj);
          if ($ctrl.$cart.hasItem(obj.id) && !obj.position) {
            var items = $ctrl.$cart.items.filter((c) => c.productId === obj.id);
            if (items.length > 1) {
              obj.qty = items[0].qtyPurchased;
              obj.price = items[0].price;
              obj.priceOverride = items[0].price;
              obj.notes = items[0].notes;
              obj.position = items[0].position;
              obj.shipOn = items[0].shipOn;
              console.info("obj", obj);
              items.forEach(function (item, index) {
                if (index > 0) {
                  var dupObj = Object.assign({}, obj);
                  dupObj.qty = item.qtyPurchased;
                  dupObj.price = item.price;
                  dupObj.priceOverride = item.price;
                  dupObj.notes = item.notes;
                  dupObj.position = item.position;
                  dupObj.shipOn = item.shipOn;
                  //dupObj.shipOn = item.shipOn.format("MM/DD/YYYY");
                  dupObj.cartItem = item;
                  args.results.push(new Product(dupObj));
                }
              });
            } else {
              //console.info("$ctrl.$cart.itemIndex[obj.id]", $ctrl.$cart.itemIndex[obj.id]);
              obj.qty = $ctrl.$cart.itemIndex[obj.id].qtyPurchased;
              obj.price = $ctrl.$cart.itemIndex[obj.id].price;
              obj.priceOverride = $ctrl.$cart.itemIndex[obj.id].price;
              obj.notes = $ctrl.$cart.itemIndex[obj.id].notes;
              obj.position = $ctrl.$cart.itemIndex[obj.id].position;
              //obj.shipOn = $ctrl.$cart.itemIndex[obj.id].shipOn.format(
              //  "MM/DD/YYYY"
              //);
              obj.shipOn = $ctrl.$cart.itemIndex[obj.id].shipOn;
              obj.cartItem = $ctrl.$cart.itemIndex[obj.id];
            }
          }
        });
      },
      scrub: ({ data }) =>
        (data.results = data.results.map(
          (p) =>
            new Product({
              qty: orderConfig.MultiAddDefaultProductMinimum
                ? p.minimumOrderQty || 1
                : 0,
              ...p,
            })
        )),
    });
  }
  setMinimums() {
    let $ctrl = this;
    $ctrl.query.results.map((p) => (p.qty = p.minimumOrderQty));
  }
  cartItemShipDate(product) {
    return cartItemShipDatePrompt({
      cartItem: product.cartItem,
      product: product,
    }).then((cartItem) => {
      product.shipOn = cartItem.shipOn.format("M/D/YY");
      product.shipOnMoment = cartItem.shipOn;
    });
  }

  save() {
    const $ctrl = this;
    return modals.confirm("You are about to add " + $ctrl.query.results.filter(q => q.qty > 0).length + " products. Continue?", "Adding Product(s)").result.then(function () {
      $ctrl.query.results
      .reduce(
        (accumulatorPromise, p) =>
          accumulatorPromise.then(() => {
            if (p.qty > 0) {
              const item = p.isInCart()
                ? $ctrl.$cart.positionIndex[p.position]
                : {};
              item.qtyPurchased = item.quantity = p.qty;
              item.notes = p.notes;
              item.shipOn = p.shipOnMoment || p.shipOn;
              //item.options = p.asShownValues || item.options || [];
              if (
                !p.isInCart() &&
                p.optionGroup &&
                !item.options.length &&
                p.asShownValues
              )
                item.options = p.asShownValues;
              if (p.priceOverride !== p.price) {
                item.priceOverride = p.priceOverride;
              }
              if (p.optionGroup && !item.options.length) {
                return Promise.resolve();
              }
              return p.isInCart()
                ? $ctrl.$cart.changeOptions(item, p)
                : $ctrl.$cart.addItem(item, p, false, "", true);
            }
          }),
        Promise.resolve()
      )
      .then(() => $ctrl.$cart.load())
      .then(() => $ctrl.$close());
    });
  }
}
